import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { StoreListResponse } from '@api/models/dashboard';
import { STORES_PAGE_SIZE } from '@shared/constants';
import { StoreSelectionStore } from '@stores/store-selection-store';
import { Observable } from 'rxjs';

export const storesResolver: ResolveFn<StoreListResponse> = (): Observable<StoreListResponse> => {
  const storeSelectionStore = inject(StoreSelectionStore);
  return storeSelectionStore.loadStores({ page: 1, pageSize: STORES_PAGE_SIZE });
};
